import React from 'react';
import PropTypes from 'prop-types';
import GeneralErrorImg from '../images/general_error.svg';
import NotFoundImg from '../images/not_found.svg';
import NoAccessImg from '../images/no_access.svg';
import MaintenanceImg from '../images/maintenance.svg';
import i18n from '../../src/i18n/translate';
import { Button } from 'react-bootstrap';
import Icon from './Icon';

export const ERROR_TYPES = {
  GENERAL_ERROR: 'general_error',
  NOT_FOUND: 'not_found',
  NO_ACCESS: 'no_access',
  MAINTENANCE: 'maintenance'
};

export default class ErrorPage extends React.Component {
  static propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    errors: PropTypes.array,
    techContact: PropTypes.shape({
      technical_contact_name: PropTypes.string,
      technical_contact_phone: PropTypes.string,
      technical_contact_email: PropTypes.string
    }),
    backButtonText: PropTypes.string,
    backButtonUrl: PropTypes.string
  };

  renderErrorMessages = () => {
    return (
      <ul className="errors">
        {this.props.errors.map((error, index) => {
          if (typeof error === 'string' || React.isValidElement(error)) {
            return <li key={`error[${index}]`} className="error-message">{error}</li>
          } else {
            return null;
          }
        })}
      </ul>
    );
  }

  renderTechnicalContact = () => {
    if (!this.props.techContact) return null;

    const { technical_contact_name: name, technical_contact_phone: phone, technical_contact_email: email } = this.props.techContact;

    return (name  || phone || email) ? (
      <div className="technical-contact p-20">
        <p className="m-b-10">{i18n.t('Please email or call your technical contact if this error persists')}</p>
        {name && <strong className="m-r-15">{name}</strong>}
        {phone && <span className="m-r-15">{phone}</span>}
        {email && <a href={`mailto:${email}`}>{email}</a>}
      </div>
    ) : null;
  }

  renderBackButton = () => {
    const { backButtonUrl, backButtonText } = this.props;

    return backButtonUrl ? (
      <Button className="btn btn-primary btn-back" href={backButtonUrl}>
        <Icon iconType="chevron-left" additionalClasses="m-l-0 m-r-5" />
        {backButtonText || i18n.t('Back to Learner Dashboard')}
      </Button>
    ) : null;
  }

  get imageUrl() {
    let imageUrl = '';
    switch (this.props.type) {
    case ERROR_TYPES.GENERAL_ERROR:
      imageUrl = GeneralErrorImg;
      break;
    case ERROR_TYPES.NOT_FOUND:
      imageUrl = NotFoundImg;
      break;
    case ERROR_TYPES.NO_ACCESS:
      imageUrl = NoAccessImg;
      break;
    case ERROR_TYPES.MAINTENANCE:
      imageUrl = MaintenanceImg;
      break;
    default:
      imageUrl = GeneralErrorImg;
    }

    return imageUrl;
  }

  render() {
    return (
      <div className="error-page-container">
        <h2>{this.props.title}</h2>
        {this.props.errors && this.renderErrorMessages()}
        <img src={this.imageUrl} alt={i18n.t('Error')} className="img-error img-fluid"/>
        {this.renderTechnicalContact()}
        {this.renderBackButton()}
      </div>
    )
  }
}
